import { QRFC } from "./QRFC";

export class QOnRampWidgetRFC extends QRFC {
  InitRFC() {
    this.InitRemoteCall(null, "POST", true, false);
  }

  SetParams(org, user, useremail) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("useremail", useremail);
  }

  GetCallName() {
    return "onramp/widget-data";
  }

  DoTransactionFailed() {
    // no-op: OnRamp is non-critical. Let GetPromise() rejection handle it.
  }
}
